import NotFound from '@/pages/NotFound';
import ROUTE_NAMES from '@/constants/routeNames';

export default [
    {
        path: '/:pathMatch(.*)*',
        component: NotFound,
        name: ROUTE_NAMES.NOT_FOUND,
        meta: {
            title: 'Brak strony - Szlachetna Paczka',
            initialIsDisplayChat: false,
            initialIsHideChatOnClose: true
        }
    }
];
